import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { CampaignStatistic } from '../../campaigns/campaign-statistic/campaign-statistic.component';
import { SelectDateService } from './select-date.service';
import { Label } from 'ng2-charts';
import { ChartType, ChartOptions } from 'chart.js';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'cumulative-campaign-statistics',
  templateUrl: './cumulative-campaign-statistics.component.html',
  styleUrls: ['./cumulative-campaign-statistics.component.css']
})

export class CumulativeCampaignStatisticsComponent implements OnInit, OnDestroy {

  public pieChartData: number[] = [];
  public pieChartLabels: Label[] = ['Not sent', 'Sent', 'Errors', 'Recieved'];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend: boolean = true;
  public pieChartColors = [
    {
      backgroundColor: ['rgba(255,0,0,0.5)',
        'rgba(0,255,0,0.5)', 'rgba(0,0,255,0.5)',
        'rgba(255,255,0,0.5)'],
    }
  ];
  public pieChartOprions: ChartOptions = {
    responsive: true,
    legend: { position: 'top' }
  };

  private campaigns: CampaignModel[] = [];
  private filteredCampaigns: CampaignModel[] = [];
  private selectedCampaignId: number[] = []; 
  private selectedStartDate: string = '';
  private selectedEndtDate: string = '';
  private reportCampaign: ReportCampaignModel = new ReportCampaignModel();
  private statistics: CampaignStatistic[] = [];
  private cumulativeStatistic: CumulativeStatistic = new CumulativeStatistic();
  private checkBoxState: boolean = false;
  private selectCapaignsErr: boolean = false;
  private startDateErr: boolean = false;
  private endDateErr: boolean = false;
  private selectDateErr: boolean = false;
  private isLoaded: boolean = false;



  private subsink = new SubSink();

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService, private selectedDate: SelectDateService) { }

  ngOnInit() {   
    $('.date-input').each(function (index, element) {
      $(element).datepicker({
        format: "dd.mm.yyyy",
        weekStart: 1,
        maxViewMode: 2,
        todayBtn: "linked",
        clearBtn: true,
        autoclose: true,
        todayHighlight: true
      });
    });

    this.getStartDate();
    this.getEndDate();

    this.subsink.sink = this.selectedDate.curentSelectedStartDate.subscribe(resp => {
      this.selectedStartDate = resp;

      if (this.selectedStartDate != '') {
        this.subsink.sink = this.selectedDate.curentSelectedEndtDate.subscribe(resp => {
          this.selectedEndtDate = resp;
          this.loadData(this.selectedStartDate, this.selectedEndtDate);
        });
      }
    })
  }

  private loadData(sDate: string, eDate: string) {
    this.subsink.sink = this.repository.get<CampaignModel[]>('api/Report/Campaigns?sDate=' + sDate + '&eDate=' + eDate).subscribe(resp => {
      this.campaigns = resp.data
      this.filteredCampaigns = this.campaigns;
    });
  }

  private getStartDate() {
    let that = this;

    $('#startDate').change(function (item) {
      let date = that.parseDate(item.target.value);
      that.selectedDate.changeSelectedStartDate(date);
    });
  }

  private getEndDate() {
    let that = this;

    $('#endDate').change(function (item) {
      let date = that.parseDate(item.target.value);
      that.selectedDate.changeSelectedEndtDate(date);
    });
  }

  private selectCampaign(value: any) {
    let campaign = this.selectedCampaignId.find(x => x == value);

    if (!campaign) {
      this.selectedCampaignId.push(value);
    } else {
      let index = this.selectedCampaignId.indexOf(campaign);
      this.selectedCampaignId.splice(index, 1);
    }
  }

  private search(searchString: string) {
    this.filteredCampaigns = this.campaigns;
    this.filteredCampaigns = this.filteredCampaigns.filter(x => x.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1)
  }

  private selectAll() {
    let that = this;

    $('.checkbox').each(function () {
      if (!that.checkBoxState) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    });

    if (!this.checkBoxState) {
      this.selectedCampaignId = [];
      this.selectedCampaignId = this.filteredCampaigns.map(x => x.id);
    } else {
      this.selectedCampaignId = [];
    }

    this.checkBoxState = !this.checkBoxState;
  }

  private parseDate(date: string) {
    if (date == '')
      return '';

    let dateArr = date.split('.');
    let year = dateArr[2];
    let month = dateArr[1];
    let day = dateArr[0];

    return year + '-' + month + '-' + day;
  }

  private applyFilters() {
    this.reportCampaign.startDate = this.selectedStartDate;
    this.reportCampaign.endDate = this.selectedEndtDate;
    this.reportCampaign.selectedCampaigns = this.selectedCampaignId;

    if (this.filtersHaveErrors(this.reportCampaign.selectedCampaigns, this.reportCampaign.startDate, this.reportCampaign.endDate)) return;

    this.subsink.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Show report', 'error');
        return;
      }

      this.subsink.sink = this.repository.post<CampaignStatistic[]>('api/Report/Report', this.reportCampaign, afResp.data).subscribe(resp => {
        if (resp.hasErrors) {
          Toast.Show(resp.error, 'Show report', 'error');
          return;
        }
        this.statistics = resp.data;

        let campaignsSum = 0;
        let msgInCampaign = 0;
        let sentMsg = 0;
        let errSent = 0;
        let recievedMsg = 0;
        let linksInMsg = 0;
        let clicksPerPhoneNum = 0;

        this.statistics.forEach(item => {
          campaignsSum += 1;
          msgInCampaign += item.messageSum;
          sentMsg += item.sentMsgSum;
          errSent += item.sendErrorSum;
          recievedMsg += item.recievedMsgSum;
          linksInMsg += item.linkSumPerMsg;
          clicksPerPhoneNum += item.sumOfClickedLinksPerPhoneNum;
        });

        this.cumulativeStatistic.campaignsSum = campaignsSum;
        this.cumulativeStatistic.msgInCampaign = msgInCampaign;
        this.cumulativeStatistic.sentMsg = sentMsg;
        this.cumulativeStatistic.errSent = errSent;
        this.cumulativeStatistic.recievedMsg = recievedMsg;
        this.cumulativeStatistic.linksInMsg = linksInMsg;
        this.cumulativeStatistic.clicksPerPhoneNum = clicksPerPhoneNum;

        msgInCampaign -= sentMsg + errSent;

        this.pieChartData = [];
        this.pieChartData.push(msgInCampaign);
        this.pieChartData.push(sentMsg);
        this.pieChartData.push(errSent);
        this.pieChartData.push(recievedMsg);

        this.isLoaded = true;
      });
    });
  }

  private filtersHaveErrors(selectedCampaigns: number[], startDate: string, endDate: string) {
    let sDate = Date.parse(startDate);
    let eDate = Date.parse(endDate);
    let haveErrors = false;

    if (selectedCampaigns.length < 1) {
      this.selectCapaignsErr = true;
    } else {
      this.selectCapaignsErr = false;
    }

    if (startDate == '') {
      this.startDateErr = true;
    } else {
      this.startDateErr = false;
    }

    if (endDate == '') {
      this.endDateErr = true;
    } else {
      this.endDateErr = false;
    }

    if (sDate > eDate) {
      this.selectDateErr = true;
    } else {
      this.selectDateErr = false;
    }

    if (this.selectCapaignsErr || this.startDateErr || this.endDateErr || this.selectDateErr)
      haveErrors = true;
    else
      haveErrors = false;

    return haveErrors;
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
    this.selectedDate.changeSelectedStartDate('');
    this.selectedDate.changeSelectedEndtDate('');
    this.reportCampaign = new ReportCampaignModel();
    this.cumulativeStatistic = new CumulativeStatistic();
    this.isLoaded = false;
  }
}

export class CampaignModel {
  id: number;
  name: string;
}

export class ReportCampaignModel {
  startDate: string;
  endDate: string;
  selectedCampaigns: number[];
}

export class CumulativeStatistic {
  campaignsSum: number;
  msgInCampaign: number;
  sentMsg: number;
  errSent: number;
  recievedMsg: number;
  linksInMsg: number;
  clicksPerPhoneNum: number;
}
